/* ==========================================================================
   ceq-cross-sell.js
   Custom Element <ceq-cross-sell> fuer die Cross-Sell-Checkliste unter dem
   "In den Warenkorb legen"-Button (Block cross_sell_checklist).

   - Haekelt der Kunde Zubehoer an, wird der CTA aktiv und zeigt
     "{n} Artikel hinzufuegen · CHF {total}".
   - Klick legt alle ausgewaehlten Varianten in EINEM /cart/add Request in den
     Warenkorb und aktualisiert den Cart-Drawer / die Cart-Notification.

   Gerendert von snippets/ceq-cross-sell-checklist.liquid.
   ========================================================================== */
if (!customElements.get('ceq-cross-sell')) {
  customElements.define(
    'ceq-cross-sell',
    class CeqCrossSell extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-cross-sell-item]'));
        this.cta = this.querySelector('[data-cross-sell-add]');
        this.label = this.querySelector('[data-cross-sell-label]');

        if (!this.cta) return;

        this.labelEmpty = this.cta.dataset.labelEmpty || '';
        this.labelAddTemplate = this.cta.dataset.labelAdd || '';
        this.currencyPrefix = this.cta.dataset.currencyPrefix || '';

        // Attribution: Handle der Anker-Produktseite, auf der das Widget laeuft.
        // Wird als versteckte Line-Item-Property (_cross_sell) an ueber das Widget
        // hinzugefuegte Varianten gehaengt -> spaeter in der Bestellung auswertbar.
        this.anchorHandle = this.dataset.anchorHandle || '';

        // Cart-Drawer / Cart-Notification fuer Refresh nach dem Hinzufuegen
        this.cart =
          document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.items.forEach((item) => {
          const checkbox = item.querySelector('[data-cross-sell-checkbox]');
          if (checkbox) {
            checkbox.addEventListener('change', () => {
              if (item.classList.contains('is-added')) {
                // Bereits im Warenkorb -> Abwaehlen entfernt den Artikel aus dem Cart.
                this.removeItem(item);
              } else {
                item.classList.toggle('is-selected', checkbox.checked);
                this.updateState();
              }
            });
          }
        });

        this.cta.addEventListener('click', () => this.onAdd());
        this.updateState();

        // Haupt-ATC abfangen: ist etwas angehakt, fuegen wir Hauptprodukt + Zubehoer
        // in EINEM /cart/add hinzu (serialisiert, kein Race, Drawer oeffnet einmal).
        this.bindMainAtc();

        // Bereits im Warenkorb liegende Artikel markieren (beim Laden + bei jeder
        // spaeteren Warenkorb-Aenderung, z.B. Entfernen im Drawer).
        this.syncWithCart();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsub = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event && event.source === 'ceq-cross-sell') return;
            this.syncWithCart();
          });
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsub) this.cartUpdateUnsub();
        if (this.mainForm && this.onMainSubmitBound) {
          this.mainForm.removeEventListener('submit', this.onMainSubmitBound, true);
        }
      }

      // Capture-Listener am Haupt-Produktformular: greift nur, wenn Zubehoer angehakt ist.
      bindMainAtc() {
        const submitBtn = document.querySelector('.ceq-buy-button__container .product-form__submit');
        this.mainForm = submitBtn ? submitBtn.closest('form') : null;
        if (!this.mainForm) return;
        this.onMainSubmitBound = this.onMainSubmit.bind(this);
        this.mainForm.addEventListener('submit', this.onMainSubmitBound, true);
      }

      onMainSubmit(event) {
        // Nichts angehakt -> normaler Dawn-Submit (nur Hauptprodukt).
        if (this.selected.length === 0 || this._combining) return;
        // Dawn-Submit-Handler ueberspringen und kombiniert hinzufuegen.
        event.preventDefault();
        event.stopImmediatePropagation();
        this.addCombined();
      }

      // EIN /cart/add fuer Hauptprodukt (inkl. aller Formularfelder) + angehaktes Zubehoer.
      addCombined() {
        if (this._combining) return;
        this._combining = true;
        const submitBtn = this.mainForm.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.classList.add('loading');

        // Hauptprodukt aus dem Formular (id, Menge, evtl. properties[...] / selling_plan).
        const fd = new FormData(this.mainForm);
        const mainItem = {
          id: parseInt(fd.get('id'), 10),
          quantity: parseInt(fd.get('quantity'), 10) || 1,
        };
        const props = {};
        fd.forEach((value, key) => {
          const m = key.match(/^properties\[(.+)\]$/);
          if (m && value) props[m[1]] = value;
        });
        if (Object.keys(props).length) mainItem.properties = props;
        const sellingPlan = fd.get('selling_plan');
        if (sellingPlan) mainItem.selling_plan = sellingPlan;

        const accessories = this.selected.map((item) => ({
          id: parseInt(item.dataset.variantId, 10),
          quantity: 1,
          properties: { _cross_sell: this.anchorHandle },
        }));

        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
        };
        const body = { items: [mainItem, ...accessories] };
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = JSON.stringify(body);

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'ceq-cross-sell',
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ceq-cross-sell', cartData: response });
            }
            this.syncWithCart();
            if (this.cart && typeof this.cart.renderContents === 'function') {
              if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              this.cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => {
            console.error('[ceq-cross-sell]', e);
          })
          .finally(() => {
            this._combining = false;
            if (submitBtn) submitBtn.classList.remove('loading');
          });
      }

      get selected() {
        return this.items.filter((item) => {
          const checkbox = item.querySelector('[data-cross-sell-checkbox]');
          // Bereits im Warenkorb liegende Artikel zaehlen nicht zur Auswahl.
          return checkbox && checkbox.checked && !item.classList.contains('is-added');
        });
      }

      // Markiert Artikel, deren Variante schon im Warenkorb liegt, als "Im Warenkorb".
      syncWithCart() {
        const url = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';
        return fetch(url, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const inCartIds = new Set((cart.items || []).map((i) => i.variant_id || i.id));
            this.items.forEach((item) => {
              const inCart = inCartIds.has(parseInt(item.dataset.variantId, 10));
              const checkbox = item.querySelector('[data-cross-sell-checkbox]');
              const wasAdded = item.classList.contains('is-added');
              item.classList.toggle('is-added', inCart);
              if (checkbox) {
                if (inCart) {
                  // Im Warenkorb -> Haken gesetzt; Abwaehlen entfernt den Artikel.
                  checkbox.checked = true;
                  item.classList.remove('is-selected');
                } else if (wasAdded) {
                  // War im Warenkorb, jetzt entfernt (z.B. im Drawer) -> zuruecksetzen.
                  checkbox.checked = false;
                  item.classList.remove('is-selected');
                }
              }
            });
            this.updateState();
          })
          .catch(() => {});
      }

      formatMoney(cents) {
        const amount = (cents / 100).toFixed(2);
        // Tausender-Gruppierung mit Komma (z.B. "3,995.00") – matcht das Live-Format des Shops
        const parts = amount.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return this.currencyPrefix + parts.join('.');
      }

      updateState() {
        const selected = this.selected;
        const count = selected.length;

        if (count === 0) {
          this.cta.setAttribute('disabled', '');
          if (this.label) this.label.textContent = this.labelEmpty;
          return;
        }

        this.cta.removeAttribute('disabled');
        const total = selected.reduce(
          (sum, item) => sum + (parseInt(item.dataset.price, 10) || 0),
          0
        );
        const text = this.labelAddTemplate
          .replace('[[count]]', count)
          .replace('[[total]]', this.formatMoney(total));
        if (this.label) this.label.textContent = text;
      }

      onAdd() {
        const selected = this.selected;
        if (selected.length === 0 || this.cta.classList.contains('is-loading')) return;

        const items = selected.map((item) => ({
          id: parseInt(item.dataset.variantId, 10),
          quantity: 1,
          properties: { _cross_sell: this.anchorHandle },
        }));

        this.cta.classList.add('is-loading');

        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
        };

        const body = { items };
        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = JSON.stringify(body);

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'ceq-cross-sell',
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'ceq-cross-sell',
                cartData: response,
              });
            }

            // Hinzugefuegte Artikel als "Im Warenkorb" markieren + Auswahl leeren.
            this.syncWithCart();

            if (this.cart && typeof this.cart.renderContents === 'function') {
              if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              this.cart.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }
          })
          .catch((e) => {
            console.error('[ceq-cross-sell]', e);
          })
          .finally(() => {
            this.cta.classList.remove('is-loading');
          });
      }

      // Entfernt die Variante aus dem Warenkorb (Abwaehlen eines "Im Warenkorb"-Artikels).
      // /cart/change erwartet den Line-Item-Key (nicht die Variant-ID) -> erst auufloesen.
      removeItem(item) {
        if (item.dataset.removing === '1') return;
        item.dataset.removing = '1';
        item.classList.add('is-removing');

        const variantId = parseInt(item.dataset.variantId, 10);
        const cartUrl = (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';

        fetch(cartUrl, { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const line = (cart.items || []).find((i) => (i.variant_id || i.id) === variantId);
            if (!line) return null; // schon nicht mehr im Warenkorb

            const config = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/javascript',
                'X-Requested-With': 'XMLHttpRequest',
              },
            };
            const body = { id: line.key, quantity: 0 };
            if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
              body.sections = this.cart.getSectionsToRender().map((section) => section.id);
              body.sections_url = window.location.pathname;
            }
            config.body = JSON.stringify(body);

            const url = (window.routes && window.routes.cart_change_url) || '/cart/change';
            return fetch(url, config).then((r) => r.json());
          })
          .then((response) => {
            if (!response) {
              this.syncWithCart();
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ceq-cross-sell', cartData: response });
            }
            this.syncWithCart();
            // Beim Entfernen NICHT renderContents() nutzen (das oeffnet den Drawer) —
            // nur die Sections still aktualisieren.
            this.updateCartSections(response);
          })
          .catch((e) => {
            console.error('[ceq-cross-sell]', e);
            this.syncWithCart();
          })
          .finally(() => {
            item.dataset.removing = '';
            item.classList.remove('is-removing');
          });
      }

      // Aktualisiert Cart-Icon-Bubble + Drawer-Inhalt aus der /cart-Response,
      // OHNE den Drawer zu oeffnen (im Gegensatz zu renderContents()).
      updateCartSections(response) {
        const cart = this.cart;
        if (!cart || !response || !response.sections) return;
        if (
          typeof cart.getSectionsToRender !== 'function' ||
          typeof cart.getSectionInnerHTML !== 'function'
        ) {
          return;
        }

        cart.getSectionsToRender().forEach((section) => {
          const el = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          const html = response.sections[section.id];
          if (el && html) {
            el.innerHTML = cart.getSectionInnerHTML(html, section.selector);
          }
        });

        if (typeof response.item_count === 'number') {
          cart.classList.toggle('is-empty', response.item_count === 0);
        }

        // Overlay-Close-Listener nach innerHTML-Replace neu binden (ohne zu oeffnen).
        const overlay = cart.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cart.close === 'function') {
          overlay.addEventListener('click', cart.close.bind(cart));
        }
      }
    }
  );
}
